import {QuestionAnswerEnum, QuestionAnswerType, QuestionReport, QuestionReportAnswer} from '../incase-domain/analytics';

export const getAnswerStatus = (answer: QuestionReportAnswer, questionReport?: QuestionReport): QuestionAnswerType => {
    if (questionReport?.isDebatable || answer.type === QuestionAnswerEnum.DEBATABLE) {
        return QuestionAnswerEnum.DEBATABLE;
    }
    return (answer.type || QuestionAnswerEnum.INCORRECT) as QuestionAnswerType;
};
